// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.PickFeatureMenu {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
}

div.PickFeatureMenu > div {
    padding: 0.25em 0.5em;
}

div.PickFeatureMenu > div:hover {
    background-color: var(--list-item-bg-color-hover);
}`, "",{"version":3,"sources":["webpack://./../qwc2/components/style/PickFeature.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD","sourcesContent":["div.PickFeatureMenu {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n}\n\ndiv.PickFeatureMenu > div {\n    padding: 0.25em 0.5em;\n}\n\ndiv.PickFeatureMenu > div:hover {\n    background-color: var(--list-item-bg-color-hover);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
